import type { EditorAPI } from '#packages/editorAPI';

export const isAppInstalled = (
  editorAPI: EditorAPI,
  appDefId: string,
): boolean =>
  editorAPI.platform.isAppActive(appDefId) ||
  editorAPI.tpa.app.isInstalled(appDefId);
